module.exports = __webpack_public_path__ + "img/20200514_154253.cf435457.jpg";